module.exports = __webpack_public_path__ + "img/login1234.aea47943.png";